<template>
    <div class="about-initiative-form12">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group label="Segmento de mercado" label-for="marketSegments" class="required">
                <b-form-checkbox-group
                    id="market-segments"
                    name="marketSegments"
                    v-model="$v.form.marketSegments.selected.$model"
                    :options="form.marketSegments.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('marketSegments')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['segmento_mercado'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['segmento_mercado'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.marketSegmentsOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.marketSegments.selected.includes(31)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('marketSegments')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Quantos sócios sua iniciativa tem?" label-for="membersNumbers">
                <b-form-select
                    id="membersNumbers"
                    name="membersNumbers"
                    v-model="form.membersNumbers.selected"
                    :options="form.membersNumbers.options"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['quantos_socios'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['quantos_socios'].value"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm5' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm5')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="
                            changeRegisterForm(
                                getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : 'AboutInitiativeForm9'
                            )
                        "
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { required } from 'vuelidate/lib/validators'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()
const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        receiveFirstData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 33.24,
            message: null,
            isUpdate: false,
            authorizationData: null,
            firstInformationData: null,
            form: {
                marketSegments: {
                    selected: [],
                    options: [
                        { text: 'Acessibilidade e Inclusão', item: 1, value: 1 },
                        { text: 'Governo', item: 2, value: 2 },
                        { text: 'Agricultura', item: 3, value: 3 },
                        { text: 'Literatura', item: 4, value: 4 },
                        { text: 'Água e Saneamento', item: 5, value: 5 },
                        { text: 'Loja (varejo)', item: 6, value: 6 },
                        { text: 'Alimentação e Nutrição', item: 7, value: 7 },
                        { text: 'Longevidade', item: 8, value: 8 },
                        { text: 'Artesanato', item: 9, value: 9 },
                        { text: 'Meio Ambiente e Sustentabilidade', item: 10, value: 10 },
                        { text: 'Audiovisual', item: 11, value: 11 },
                        { text: 'Moda', item: 12, value: 12 },
                        { text: 'Cidades: Mobilidade, Habitação e Transporte', item: 13, value: 13 },
                        { text: 'Prestação de serviço', item: 14, value: 14 },
                        { text: 'Cidadania (Cultura, Esporte e Advocacy)', item: 15, value: 15 },
                        { text: 'Produtos e Serviços Financeiros', item: 16, value: 16 },
                        { text: 'Reforma', item: 17, value: 17 },
                        { text: 'Ciência', item: 18, value: 18 },
                        { text: 'Resíduos e Permacultura', item: 19, value: 19 },
                        { text: 'Combate a Desigualdade', item: 20, value: 20 },
                        { text: 'Salão de Beleza', item: 21, value: 21 },
                        { text: 'Comunicação e Jornalismo', item: 22, value: 22 },
                        { text: 'Saúde e Bem-estar', item: 23, value: 23 },
                        { text: 'Direitos Humanos', item: 24, value: 24 },
                        { text: 'Suporte ao Empreendedorismo', item: 25, value: 25 },
                        { text: 'Educação e Formação', item: 26, value: 26 },
                        { text: 'Tecnologia', item: 27, value: 27 },
                        { text: 'Empregabilidade e Geração de Renda', item: 28, value: 28 },
                        { text: 'Turismo e Ecoturismo', item: 29, value: 29 },
                        { text: 'Energia', item: 30, value: 30 },
                        { text: 'Outros (especifique)', item: 31, value: 31 }
                    ]
                },
                marketSegmentsOthers: null,
                membersNumbers: {
                    selected: null,
                    options: [
                        { value: null, text: 'Selecione' },
                        { value: 1, text: '1' },
                        { value: 2, text: '2' },
                        { value: 3, text: '3' },
                        { value: 4, text: '4' },
                        { value: 5, text: '5' },
                        { value: 6, text: '6' },
                        { value: 7, text: '7' },
                        { value: 8, text: '8' },
                        { value: 9, text: '9' },
                        { value: 10, text: '10' },
                        { value: 11, text: 'Mais de 10' }
                    ]
                }
            }
        }
    },
    validations: {
        form: {
            marketSegments: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.membersNumbers.selected = data.quantos_socios

            this.form.marketSegments.selected =
                data.segmento_mercado === null ? [] : data.segmento_mercado.filter(item => typeof item === 'number')

            this.form.marketSegmentsOthers =
                data.segmento_mercado === null
                    ? null
                    : data.segmento_mercado.filter(item => typeof item !== 'number')[0].marketSegmentsOthers

            this.firstInformationData = this.receiveFirstData
            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative(), registerFirstInformationApi.listFirst()])
                .then(response => {
                    const data = response[0].data.data
                    this.firstInformationData = response[1].data

                    if (data !== null) {
                        this.initiative = data
                        this.form.membersNumbers.selected = data.quantos_socios

                        this.form.marketSegments.selected =
                            data.segmento_mercado === null
                                ? []
                                : data.segmento_mercado.filter(item => typeof item === 'number')

                        this.form.marketSegmentsOthers =
                            data.segmento_mercado === null
                                ? null
                                : data.segmento_mercado.filter(item => typeof item !== 'number')[0].marketSegmentsOthers
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                segmento_mercado: this.form.marketSegments.selected,
                quantos_socios: this.form.membersNumbers.selected,
                percentual: currentProgress
            }

            data.segmento_mercado = [...data.segmento_mercado, { marketSegmentsOthers: this.form.marketSegmentsOthers }]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({
                            name:
                                this.getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : this.getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : this.initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : 'AboutInitiativeForm9'
                        })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.marketSegments.options = this.form.marketSegments.options.filter(x =>
                    this.form.marketSegments.selected.includes(x.value)
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getFirstInformation() {
            return this.firstInformationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm12-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm12.vue